import React from "react";
import { Dialog } from "@headlessui/react";
import { useNavigate } from "react-router-dom";

const RequireAuthPopup = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      <div className="fixed inset-0 z-10 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
          <h2 className="text-lg font-semibold text-gray-900 text-center">
            Please Sign In or Sign Up
          </h2>
          <p className="text-sm text-gray-500 text-center mt-2">
            You need to be signed in to access this feature.
          </p>
          <div className="mt-6 flex justify-center gap-4">
            <button
              className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-500"
              onClick={() => {
                navigate("/login");
                onClose();
              }}
            >
              Log In
            </button>
            <button
              className="rounded-md bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-200"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default RequireAuthPopup;
